import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-commitment-follow-modal',
  templateUrl: './commitment-follow-modal.component.html',
  styleUrls: ['./commitment-follow-modal.component.css'],
})
export class CommitmentFollowModalComponent  implements OnInit {
 @Input() type!: string;

  get postTypeLabel(): string {
  switch (this.type) {
    case 'idea':
      return 'Idea';
    case 'proposition':
      return 'Solution';
    case 'thinkTank':
      return 'Think Tank';
    default:
      return 'Item';
  }
}

  constructor(
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {}


  onFollowClick() {
    this.modalCtrl.dismiss({ action: 'subscribe' });
  }

  onCancelClick() {
    this.modalCtrl.dismiss();
  }
}
